import { render, staticRenderFns } from "./FabricFamilies.vue?vue&type=template&id=5548c060&scoped=true"
import script from "./FabricFamilies.vue?vue&type=script&lang=js"
export * from "./FabricFamilies.vue?vue&type=script&lang=js"
import style0 from "./FabricFamilies.vue?vue&type=style&index=0&id=5548c060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5548c060",
  null
  
)

export default component.exports